// Third Party Imports
import React from 'react';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {FormInput, FormTextArea} from '@homeaway/react-form-components';
import Modal from '@homeaway/react-modal';

// Relative Imports
import './HelpForm.less';
import AlertBox from '../Alert/Alert';
import ReCAPTCHA from 'react-google-recaptcha';
import {getKey, processTranslationReplaceAll} from '../utils/commonUtil';

const HelpForm = (props) => {
    let {
        isHelpModalOpen,
        isUnlistedSoftware,
        handleClose,
        translations,
        scrollTop,
        scrollModalToTop,
        serviceError,
        serviceSuccess,
        handleAlertDismiss,
        appActions,
        handleFieldValOnChange,
        handleFieldValOnBlur,
        emailVal,
        emailError,
        firstNameVal,
        firstNameError,
        lastNameVal,
        lastNameError,
        phoneNumberVal,
        phoneNumberError,
        companyNameVal,
        companyNameError,
        helpSubVal,
        helpSubError,
        helpMessageVal,
        propertyCountVal,
        propertyCountError,
        softwareNameVal,
        softwareNameError,
        helpMessageError,
        onCaptchaChange,
        handleSubmit,
        setRecaptchaRef,
        environment,
        brandName
    } = props;

    const helpTitle = processTranslationReplaceAll(translations['ipmob.help_page.header'], [brandName]);

    return (
        <Modal
            id="modalHelp"
            isOpen={isHelpModalOpen}
            isWorkflow
            onClose={handleClose}
            title={helpTitle}
            scrollTop={scrollTop}
            scrollToTop={scrollModalToTop}
        >
            <div>
                {
                    (serviceError || serviceSuccess)
                        ? (
                            <AlertBox
                                messageKey={serviceSuccess || serviceError}
                                translations={translations}
                                handleAlertDismiss={handleAlertDismiss}
                                type={(serviceSuccess) ? 'Alert Success' : 'Alert Error'}
                                targetPage={'Help page'}
                                appActions={appActions}
                            />
                        )
                        : null
                }
                <div className="mdl-wrapper">
                    <div className="mdl-col">
                        <p className="help-sub-head">
                            {translations['ipmob.ineligible_help.sub_heading']}
                        </p>
                    </div>
                    <div className="mdl-col-left">
                        <div className="mdl-wrapper">
                            <div className="mdl-col">
                                <FormInput
                                    id="email"
                                    className="email"
                                    type="email"
                                    name="Email Address"
                                    label={translations['ipmob.create_account.label_5']}
                                    value={emailVal}
                                    errorMsg={translations[emailError]}
                                    onChange={handleFieldValOnChange}
                                    onBlur={handleFieldValOnBlur}
                                    maxLength="64"
                                />
                            </div>
                        </div>
                        <div className="mdl-wrapper">
                            <div className="mdl-col">
                                <FormInput
                                    id="firstName"
                                    type="text"
                                    name="First Name"
                                    label={translations['ipmob.create_account.label_3']}
                                    value={firstNameVal}
                                    errorMsg={translations[firstNameError]}
                                    onChange={handleFieldValOnChange}
                                    onBlur={handleFieldValOnBlur}
                                    maxLength="64"
                                />
                            </div>
                        </div>
                        <div className="mdl-wrapper">
                            <div className="mdl-col">
                                <FormInput
                                    id="lastName"
                                    type="text"
                                    name="Last Name"
                                    label={translations['ipmob.create_account.label_4']}
                                    value={lastNameVal}
                                    errorMsg={translations[lastNameError]}
                                    onChange={handleFieldValOnChange}
                                    onBlur={handleFieldValOnBlur}
                                    maxLength="64"
                                />
                            </div>
                        </div>
                        <div className="mdl-wrapper">
                            <div className="mdl-col">
                                <FormInput
                                    id="phoneNumber"
                                    type="text"
                                    name="Phone Number"
                                    label={translations['ipmob.create_account.label_8']}
                                    value={phoneNumberVal}
                                    errorMsg={translations[phoneNumberError]}
                                    onChange={handleFieldValOnChange}
                                    onBlur={handleFieldValOnBlur}
                                    maxLength="64"
                                />
                            </div>
                        </div>
                        <div className="mdl-wrapper">
                            <div className="mdl-col">
                                <FormInput
                                    id="companyName"
                                    type="text"
                                    name="Company Name"
                                    label={translations['ipmob.help_page.label_5']}
                                    value={companyNameVal}
                                    errorMsg={translations[companyNameError]}
                                    onChange={handleFieldValOnChange}
                                    onBlur={handleFieldValOnBlur}
                                    maxLength="64"
                                />
                            </div>
                        </div>

                        {
                            isUnlistedSoftware 
                            ? (
                                <div className="mdl-wrapper">
                                    <div className="mdl-col">
                                        <FormInput
                                            id="propertyCount"
                                            type="number"
                                            name="Property Count"
                                            label={translations['ipmob.property_count.label']}
                                            value={propertyCountVal}
                                            errorMsg={translations[propertyCountError]}
                                            onChange={handleFieldValOnChange}
                                            onBlur={handleFieldValOnBlur}
                                            maxLength="10"
                                        />
                                    </div>
                                </div>
                            ) : null
                        }
                    </div>
                    <div className="mdl-col-right">
                        {
                            isUnlistedSoftware 
                            ? (
                                <div className="mdl-wrapper">
                                    <div className="mdl-col">
                                        <FormInput
                                            id="softwareName"
                                            type="text"
                                            name="Software Name"
                                            label={translations['ipmob.software_details.label_1']}
                                            value={softwareNameVal}
                                            errorMsg={translations[softwareNameError]}
                                            onChange={handleFieldValOnChange}
                                            onBlur={handleFieldValOnBlur}
                                            maxLength="64"
                                        />
                                    </div>
                                </div>
                            ) : null
                        }
                        <div className="mdl-wrapper">
                            <div className="mdl-col">
                                <FormInput
                                    id="helpSubject"
                                    className="help-subject"
                                    type="text"
                                    name="Help Subject"
                                    label={`${translations['ipmob.help_page.subject']}. . .`}
                                    value={helpSubVal}
                                    errorMsg={translations[helpSubError]}
                                    onChange={handleFieldValOnChange}
                                    onBlur={handleFieldValOnBlur}
                                    maxLength="64"
                                />
                            </div>
                        </div>
                        <div className="mdl-wrapper">
                            <div className="mdl-col">
                                <FormTextArea
                                    id="helpMessage"
                                    className="help-message"
                                    label={`${translations['ipmob.help_page.message']}. . .`}
                                    rows={10}
                                    value={helpMessageVal}
                                    errorMsg={translations[helpMessageError]}
                                    onChange={handleFieldValOnChange}
                                    onBlur={handleFieldValOnBlur}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mdl-wrapper">
                    <div className="mdl-col-left"/>
                    <div className="mdl-col-captcha">
                        <ReCAPTCHA
                            ref ={setRecaptchaRef}
                            sitekey={`${getKey(environment)}`}
                            size="invisible"
                            onChange={onCaptchaChange}
                        />
                    </div>
                </div>
                <div className="mdl-wrapper">
                    <div className="mdl-col-help">
                        <ButtonPrimary
                            type="submit"
                            onClick={handleSubmit}
                            className="help-btn"
                            label={translations['ipmob.help_page.submit']}
                            size="sm"
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default HelpForm;